export const PLANT_POPULATION_ANALYSIS_COLOURS = [
  '#3e1150',
  '#41397F',
  '#3f6b8b',
  '#5bb380',
  '#a0d55b',
  '#f9e855',
];
